export const CREATE_WISH_REQUEST = "CREATE_WISH_REQUEST";
export const CREATE_WISH_SUCCESS = "CREATE_WISH_SUCCESS";
export const CREATE_WISH_FAILURE = "CREATE_WISH_FAILURE";

export const GET_WISH_REQUEST = "GET_WISH_REQUEST";
export const GET_WISH_SUCCESS = "GET_WISH_SUCCESS";
export const GET_WISH_FAILURE = "GET_WISH_FAILURE";

export const GET_WISH_BYID_REQUEST = "GET_WISH_BYID_REQUEST";
export const GET_WISH_BYID_SUCCESS = "GET_WISH_BYID_SUCCESS";
export const GET_WISH_BYID_FAILURE = "GET_WISH_BYID_FAILURE";

export const UPDATE_WISH_BYID_REQUEST = "UPDATE_WISH_BYID_REQUEST";
export const UPDATE_WISH_BYID_SUCCESS = "UPDATE_WISH_BYID_SUCCESS";
export const UPDATE_WISH_BYID_FAILURE = "UPDATE_WISH_BYID_FAILURE";

export const DELETE_WISH_BYID_REQUEST = "DELETE_WISH_BYID_REQUEST";
export const DELETE_WISH_BYID_SUCCESS = "DELETE_WISH_BYID_SUCCESS";
export const DELETE_WISH_BYID_FAILURE = "DELETE_WISH_BYID_FAILURE";